import type { Ticket } from "../api/tickets";

// Local calendar date as YYYY-MM-DD. NOT UTC — using UTC would mis-bucket
// tickets around local midnight.
export function localToday(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export interface TodaySections {
  doing: Ticket[]; // 進行中
  due: Ticket[]; // 今天到期 / 逾期
  next: Ticket[]; // 接下來該碰
  blockedCount: number; // 摘要提示用,不開工作區
}

const DUE_STATUSES: Ticket["status"][] = ["todo", "backlog", "blocked"];

function byPriority(a: Ticket, b: Ticket): number {
  return (
    a.priority - b.priority ||
    (a.end_date ?? "9999-99-99").localeCompare(b.end_date ?? "9999-99-99") ||
    b.updated_at.localeCompare(a.updated_at)
  );
}

export function todaySections(all: Ticket[], today: string): TodaySections {
  const doing = all.filter((t) => t.status === "doing");
  // ISO YYYY-MM-DD strings compare correctly with <= ; overdue counts as due.
  const due = all.filter(
    (t) =>
      DUE_STATUSES.includes(t.status) && !!t.end_date && t.end_date <= today,
  );
  const dueIds = new Set(due.map((t) => t.id));
  const next = all.filter(
    (t) => t.status === "todo" && t.priority <= 2 && !dueIds.has(t.id),
  );
  const blockedCount = all.filter((t) => t.status === "blocked").length;
  return {
    doing: [...doing].sort(byPriority),
    due: [...due].sort(byPriority),
    next: [...next].sort(byPriority),
    blockedCount,
  };
}
